import { getWidth } from "../../../utils/relativeSizes";

export const kukariStyle = {
  kukari_1_0: {
    transform: [{ translateY: -getWidth(10.5) }]
  },
  kukari_2_0: {
    transform: [{ translateY: -getWidth(12.5) }, { translateX: -getWidth(3.5) }, { scale: 0.7 }]
  },
  kukari_2_1: {
    transform: [{ translateY: getWidth(-2.5) }, { translateX: getWidth(3.5) }, { scale: 0.7 }]
  },
  kukari_3_0_t_b: {
    transform: [{ translateY: -getWidth(9.5) }, { translateX: getWidth(5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_3_1_t_b: {
    transform: [{ translateY: -getWidth(9.5) }, { translateX: -getWidth(5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_3_2_t_b: {
    transform: [{ translateY: -getWidth(0.5) }, { translateX: getWidth(0) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_3_0: {
    transform: [{ translateY: -getWidth(11.5) }, { translateX: getWidth(0) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_3_1: {
    transform: [{ translateY: -getWidth(2) }, { translateX: -getWidth(5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_3_2: {
    transform: [{ translateY: -getWidth(2) }, { translateX: getWidth(5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_4_0: {
    transform: [{ translateX: getWidth(5) }, { translateY: getWidth(-9.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_4_1: {
    transform: [{ translateX: getWidth(-5) }, { translateY: getWidth(-9.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_4_2: {
    transform: [{ translateX: getWidth(5) }, { translateY: getWidth(-0.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_4_3: {
    transform: [{ translateX: getWidth(-5) }, { translateY: getWidth(-0.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_5_0: {
    transform: [{ translateX: getWidth(-5) }, { translateY: getWidth(-9.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_5_1: {
    transform: [{ translateX: getWidth(5) }, { translateY: getWidth(-9.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_5_2: {
    transform: [{ translateX: getWidth(0) }, { translateY: getWidth(-4.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_5_3: {
    transform: [{ translateX: getWidth(-5) }, { translateY: getWidth(-0.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_5_4: {
    transform: [{ translateX: getWidth(5) }, { translateY: getWidth(-0.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_6_0: {
    transform: [{ translateX: getWidth(-5) }, { translateY: getWidth(-9.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_6_1: {
    transform: [{ translateX: getWidth(5) }, { translateY: getWidth(-9.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_6_2: {
    transform: [{ translateX: getWidth(-5) }, { translateY: getWidth(-4.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_6_3: {
    transform: [{ translateX: getWidth(5) }, { translateY: getWidth(-4.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_6_4: {
    transform: [{ translateX: getWidth(-5) }, { translateY: getWidth(-0.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
  kukari_6_5: {
    transform: [{ translateX: getWidth(5) }, { translateY: getWidth(-0.5) }, { scaleX: 0.56 }, { scaleY: 0.58 }]
  },
}

export const boxStyle = {
  width: getWidth(21),
  height: getWidth(20.5),
}